import { useMutation } from '@tanstack/react-query';

import { setAdminComplianceTypeVisibilityBulk } from './setAdminComplianceTypeVisibilityBulk';

/**
 * Sets the same show/hide state on many compliance types in one request. Admin-only (guarded server-side).
 * The catalog list is read through SWR, so callers refresh it with that hook's `mutate` in `onSuccess`.
 */
export function useSetAdminComplianceTypeVisibilityBulk(opts?: {
  onSuccess?: () => void | Promise<void>;
  onError?: (error: Error) => void;
}) {
  return useMutation({
    mutationFn: setAdminComplianceTypeVisibilityBulk,
    onSuccess: opts?.onSuccess,
    onError: opts?.onError,
  });
}
